export default {
  identity: {
    id: 1,
    dba_name: 'DHL Express, LLC',
    dot: 123456,
    mc_docket: 123456,
    authority: 'Common Contract Broker',
    legal_name: 'Jim Halpert',
    physical_address: {
      street1: '3455 W Missoula Ave',
      street2: '',
      city: 'Bozeman',
      state: 'MT',
      zip: '59715',
      country: 'USA',
    },
    mailing_address: {
      street1: '9876 Cartier Blvd',
      street2: 'Suite 123',
      city: 'Missoula',
      state: 'MT',
      zip: '59801',
      country: 'USA',
    },
    authorities: [],
    contact_information: [
      {
        phone_number: '123-456-7890',
        email: 'username@email.com',
      },
      {
        phone_number: '123-456-7890',
        email: 'username@gmail.com',
      },
      {
        phone_number: '123-456-7890',
        email: null,
      },
    ],
  },
  fax_number: '1234567890',
  website: 'www.dhlexpress.com',
  company_classification: 'Corporation',
  ssn: '',
  dispatcher_phone_number: '',
  dispatcher_email: '',
  tracked_certifications: [
    { title: 'Hazmat', certification_id: 123456789, certified: true },
    {
      title: 'Smartway',
      certification_id: null,
      certified: false,
    },
    {
      title: 'Carb Tru',
      certification_id: 512561459,
      certified: true,
    },
  ],
  tax_payer_id: '1234567890',
  federal_tax_class: '',
  contracts_information: {
    tin_value: '',
    tin_type: '',
    tax_classification: '',
    dba_name: 'DHL Express, LLC',
    legal_name: 'Jim Halpert',
    address_1: '3455 W Missoula Ave',
    address_2: '',
    city: 'Bozeman',
    state: 'MT',
    zip: '59715',
    country: 'USA',
  },
  lanes: {
    regions: [],
    countries: {
      canada: '',
      mexico: '',
    },
    by_state: {
      preferred_areas: [],
      inspection_areas: [
        {
          id: 2,
          code: 'AL',
          name: 'ALABAMA',
          is_type: 'state',
          number_of_inspections: 15,
        },
        {
          id: 4,
          code: 'AZ',
          name: 'ARIZONA',
          is_type: 'state',
          number_of_inspections: 1,
        },
        {
          id: 6,
          code: 'CO',
          name: 'COLORADO',
          is_type: 'state',
          number_of_inspections: 1,
        },
        {
          id: 7,
          code: 'CT',
          name: 'CONNECTICUT',
          is_type: 'state',
          number_of_inspections: 3,
        },
        {
          id: 10,
          code: 'FL',
          name: 'FLORIDA',
          is_type: 'state',
          number_of_inspections: 2,
        },
        {
          id: 11,
          code: 'GA',
          name: 'GEORGIA',
          is_type: 'state',
          number_of_inspections: 12,
        },
        {
          id: 14,
          code: 'ID',
          name: 'IDAHO',
          is_type: 'state',
          number_of_inspections: 1,
        },
        {
          id: 15,
          code: 'IL',
          name: 'ILLINOIS',
          is_type: 'state',
          number_of_inspections: 1,
        },
        {
          id: 16,
          code: 'IN',
          name: 'INDIANA',
          is_type: 'state',
          number_of_inspections: 12,
        },
        {
          id: 18,
          code: 'KY',
          name: 'KENTUCKY',
          is_type: 'state',
          number_of_inspections: 28,
        },
      ],
    },
  },
  integrations: {
    systems: [],
    shared_data: [],
  },
  payment: {
    edit: {
      factor: false,
      check_ach: false,
    },
    bank: 'Bank Name',
    payment_type: '',
    payment_source: '',
    verification_code: '',
    errors: false,
  },
  untracked_certifications: [],
  alternate_contacts: [],
  total_power_units: '10',
  total_drivers: '10',
  popular_trailer_types: [],
  other_trailer_types: [],
  specializations: [],
  authorize_name: '',
  authorize_signature: false,
  errors: false,
  auto_liability_insurance: {
    agency: {
      name: '',
      location: '',
      email: '',
      phone_number: '',
    },
  },
  cargo_insurance: {
    agency: {
      name: '',
      location: '',
      email: '',
      phone_number: '',
    },
    policy_exclusions: [],
  },
  same_agency: false,
  additional_questions: {
    step_one: {
      message: '',
      yes_no: '',
      checkbox: [],
    },
    step_two: {
      input_1: '',
      dropdown: '',
      checkbox: [],
      yes_no: '',
      input_2: '',
    },
    step_three: {
      dropdown: '',
      yes_no: '',
      input: '',
    },
  },
  login_phone_number: '',
  login_verification_code: '',
};

// TODO --USE THIS DATA -- back up for testing purposes
// eslint-disable-next-line
const data = {
  id: 3275805,
  name: 'METCALF TRUCKING LLC',
  legal_name: 'METCALF TRUCKING LLC',
  dba_name: null,
  identifiers: [
    {
      id: 4616898,
      is_type: 'DOT',
      value: '03790205',
      value_non_padded: 3790205,
      carrier_id: 3275805,
    },
    {
      id: 4616899,
      is_type: 'MC',
      value: '1367023',
      value_non_padded: 1367023,
      carrier_id: 3275805,
    },
  ],
  dispatch_contact: {
    name: 'Tim Biles',
    phone: null,
    email_address: 'timbilestimbiles@gmail.com',
  },
  verified_certifications: {
    carb_tru: false,
    hazmat: false,
    smart_way: false,
  },
  assessment: {
    rating: 'Review Required',
    is_active_carrier_authority: true,
    is_active_insurance: true,
    no_out_of_service_order: true,
    is_satisfactory_safety_rating: true,
    is_operating_status_active: true,
    is_inspection_history_greater_than_zero: false,
    latest_safety_rating: null,
  },
  lane_preferences: {
    by_state: {
      preferred_areas: [],
      headquarter_areas: [
        {
          id: 44,
          code: 'TN',
          name: 'TENNESSEE',
          is_type: 'state',
        },
      ],
      inspection_areas: [],
    },
    by_kma: {
      preferred_areas: [],
      headquarter_areas: [
        {
          id: 37064,
          code: 'TN_NAS',
          name: 'Nashville, TN',
          is_type: 'kma',
        },
      ],
      inspection_areas: [],
    },
  },
  headquarters: {
    five_zip_area: {
      id: 25445,
      code: '37127',
      name: '37127',
      is_type: 'five_zip',
      centroid_svg: "x='-961' y='-427'",
      centroid_svg_x: -961.0,
      centroid_svg_y: -427.0,
    },
    address: {
      id: 6690175,
      lat: null,
      lon: null,
      carrier_id: 3275805,
      is_type: 'physical',
      street1: '2314 PEACH BLOSSOM CT',
      street2: '',
      city: 'MURFREESBORO',
      state: 'TN',
      postal_code: '37127',
      commonly_reused_count: 0,
    },
  },
  survey_call_notes: {
    surveys: [],
    first_contact_date: null,
    last_contact_date: null,
  },
  authority: {
    authorities: {
      common_authority_status: 'Active',
      continuous_authority_grant_date_common: '2022-02-07',
      contract_authority_status: null,
      continuous_authority_grant_date_contract: null,
      broker_authority_status: null,
      continuous_authority_grant_date_broker: null,
    },
    licensed_capabilities: ['Property'],
    histories: [
      {
        id: 5292668,
        authority_type: 'MOTOR PROPERTY COMMON CARRIER',
        carrier_id: 3275805,
        file_date: '2022-02-07',
        sequence_number: null,
        original_action: 'GRANTED',
        original_action_date: '2022-02-07',
        disposition_action: null,
        disposition_date: null,
      },
    ],
    out_of_service_rates: {
      id: 5073522,
      file_date: '2022-02-28',
      driver_fitness_inspections: 0,
      driver_fitness_oos_inspections: 0,
      driver_fitness_oos_rate: 0.0,
      driver_fitness_oos_rate_national_average: 5.51,
      hazmat_inspections: 0,
      hazmat_oos_inspections: 0,
      hazmat_oos_rate: 0.0,
      hazmat_oos_rate_national_average: 4.5,
      vehicle_maintenance_inspections: 0,
      vehicle_maintenance_oos_inspections: 0,
      vehicle_maintenance_oos_rate: 0.0,
      vehicle_maintenance_oos_rate_national_average: 20.72,
    },
  },
  insurance: {
    active_and_pending_insurance: [
      {
        id: 9686648,
        status: 'Active or Pending',
        insurance_type: 'BIPD/Primary',
        policy_number: 'CA954212264',
        effective_date: '2022-02-01',
        carrier_id: 3275805,
        file_date: '2022-02-07',
        li_insurer_id: 25563,
        cancel_method: null,
        cancel_form_code: null,
        cancel_effective_date: null,
        is_type: 'active_pending',
        coverage: 1000,
        cancellation_date: null,
        insurer_name: 'PROGRESSIVE HAWAII INSURANCE CORP',
      },
    ],
    histories: [
      {
        id: 9653076,
        status: 'Canceled',
        insurance_type: 'BIPD/Primary',
        policy_number: 'CA954212264',
        effective_date: '2022-02-01',
        carrier_id: 3275805,
        file_date: '2022-02-07',
        li_insurer_id: 25563,
        cancel_method: 'Replaced',
        cancel_form_code: '91X',
        cancel_effective_date: '2022-02-01',
        is_type: 'history',
        coverage: 750,
        cancellation_date: '2022-02-01',
        insurer_name: 'PROGRESSIVE HAWAII INSURANCE CORP',
      },
    ],
  },
  safety: {
    safety_rating: null,
    safety_rating_effective_date: null,
    sms_basics: [
      {
        id: 24333170,
        unsafe_driving_measure: 0.0,
        hos_compliance_measure: 0.0,
        vehicle_maintenance_measure: 0.0,
        controlled_substance_measure: 0.0,
        driver_fitness_measure: 0.0,
        file_date: '2022-01-01',
        carrier_id: 3275805,
      },
    ],
    percentiles: {
      unsafe_driving: {
        bottom_ten_percent: 11.47,
        top_ten_percent: 0.0,
        carriers_percentile: 'Top 10%',
      },
      hos_compliance: {
        bottom_ten_percent: 3.83,
        top_ten_percent: 0.0,
        carriers_percentile: 'Top 10%',
      },
      vehicle_maintenance: {
        bottom_ten_percent: 14.0,
        top_ten_percent: 0.0,
        carriers_percentile: 'Top 10%',
      },
      controlled_substance: {
        bottom_ten_percent: 0.0,
        top_ten_percent: 0.0,
        carriers_percentile: 'Top 10%',
      },
      driver_fitness: {
        bottom_ten_percent: 0.0,
        top_ten_percent: 0.0,
        carriers_percentile: 'Top 10%',
      },
    },
  },
  violations: {
    total: 0,
    unsafe_driving: {
      total: 0,
      violations: [],
    },
    hos_compliance: {
      total: 0,
      violations: [],
    },
    vehicle_maintenance: {
      total: 0,
      violations: [],
    },
    controlled_substance: {
      total: 0,
      violations: [],
    },
    driver_fitness: {
      total: 0,
      violations: [],
    },
  },
  inspections: {
    insights: [],
    observed_power_units: null,
    reported_power_units: 1,
    percentile_ranking_compared_to_peers: 'Bottom 10%',
    length_of_authority_in_months: 0,
    records: [],
  },
  crashes: {
    total: 0,
    records: [],
  },
  equipment: {
    insights: [],
    vehicles: [],
  },
  equipment_portfolio: {
    id: 3275805,
    carrier_id: 3275805,
    van_trailers: 0,
    reefer_trailers: 0,
    flatbed_trailers: 0,
    tanker_trailers: 0,
    intermodal_trailers: 0,
    pneumatic_trailers: 0,
    dumps_trailers: 0,
    car_hauler_trailers: 0,
    double_drop_trailers: 0,
    lowboy_trailers: 0,
    grain_trailers: 0,
    livestock_trailers: 0,
    heavy_haul_trailers: 0,
    drop_deck_trailers: 0,
    refuse_transfer_trailers: 0,
    forestry_trailers: 0,
    total_observed_trailers: 0,
    truck_tractors: 0,
    cargo_vans: 0,
    straight_box_trucks: 0,
    total_observed_power_units: 0,
  },
  operations: {
    classifications: ['Authorized For Hire'],
    operating_status: 'AUTHORIZED FOR Property',
    operating_status_date: '2022-02-12',
    fleet_size: '0-1',
    mcsip_step_description: null,
    mcsip_date: null,
    cargo_carried: [
      {
        id: 1,
        name: 'General Freight',
      },
    ],
    entity_types: [
      {
        id: 1,
        name: 'Carrier',
      },
    ],
    total_power_units: 99,
    total_drivers: 105,
    equipment_types: [
      {
        id: 425089,
        carrier_id: 3275805,
        is_type: 'flatbed',
        file_date: '2022-02-26',
        equipment_typeable_id: 18,
        equipment_typeable_type: 'OnboardingPacket',
        created_at: '2022-02-26T20:07:37.533-06:00',
        updated_at: '2022-02-26T20:07:37.533-06:00',
      },
      {
        id: 425090,
        carrier_id: 3275805,
        is_type: 'reefer',
        file_date: '2022-02-26',
        equipment_typeable_id: 18,
        equipment_typeable_type: 'OnboardingPacket',
        created_at: '2022-02-26T20:07:42.977-06:00',
        updated_at: '2022-02-26T20:07:42.977-06:00',
      },
      {
        id: 425088,
        carrier_id: 3275805,
        is_type: 'van',
        file_date: '2022-02-26',
        equipment_typeable_id: 18,
        equipment_typeable_type: 'OnboardingPacket',
        created_at: '2022-02-26T20:05:56.031-06:00',
        updated_at: '2022-02-26T20:05:56.031-06:00',
      },
    ],
    specializations: [
      {
        id: 149497,
        carrier_id: 3275805,
        is_type: 'alaska',
        file_date: '2022-02-26',
        specializationable_id: 18,
        specializationable_type: 'OnboardingPacket',
        created_at: '2022-02-26T20:00:10.360-06:00',
        updated_at: '2022-02-26T20:00:10.360-06:00',
      },
      {
        id: 149498,
        carrier_id: 3275805,
        is_type: 'regional',
        file_date: '2022-02-26',
        specializationable_id: 18,
        specializationable_type: 'OnboardingPacket',
        created_at: '2022-02-26T20:01:12.227-06:00',
        updated_at: '2022-02-26T20:01:12.227-06:00',
      },
      {
        id: 149499,
        carrier_id: 3275805,
        is_type: 'ctpat',
        file_date: '2022-02-26',
        specializationable_id: 18,
        specializationable_type: 'OnboardingPacket',
        created_at: '2022-02-26T20:01:26.752-06:00',
        updated_at: '2022-02-26T20:01:26.752-06:00',
      },
    ],
  },
  contact_information: {
    contacts: [
      {
        id: 7761464,
        name: 'Tim Biles',
        is_type: 'dispatch',
        carrier_id: 3275805,
        is_contacted: false,
        latest_contacted_date: null,
        commonly_reused_count: 0,
      },
      {
        id: 7721139,
        name: 'CHARNIQUA METCALF',
        is_type: 'census',
        carrier_id: 3275805,
        is_contacted: false,
        latest_contacted_date: null,
        commonly_reused_count: 0,
      },
      {
        id: 7721140,
        name: 'TARAY METCALF',
        is_type: 'census',
        carrier_id: 3275805,
        is_contacted: false,
        latest_contacted_date: null,
        commonly_reused_count: 0,
      },
    ],
    phones: [
      {
        id: 4664465,
        is_type: 'census_main',
        phone_e164: '+18178813993',
        error_code: null,
        carrier_name: 'AT&T Wireless',
        caller_name: null,
        value: '(817) 881-3993',
        is_contacted: false,
        latest_contacted_date: null,
        commonly_reused_count: 0,
      },
      {
        id: 4664469,
        is_type: 'census_main',
        phone_e164: '+12019532240',
        error_code: null,
        carrier_name: 'Verizon Wireless',
        caller_name: null,
        value: '(201) 953-2240',
        is_contacted: false,
        latest_contacted_date: null,
        commonly_reused_count: 0,
      },
      {
        id: 4664468,
        is_type: 'census_main',
        phone_e164: '+18174569649',
        error_code: null,
        carrier_name: 'T-Mobile USA, Inc.',
        caller_name: null,
        value: '(817) 456-9649',
        is_contacted: false,
        latest_contacted_date: null,
        commonly_reused_count: 0,
      },
      {
        id: 4664464,
        is_type: 'census_main',
        phone_e164: '+12142260764',
        error_code: null,
        carrier_name: 'AT&T Wireless',
        caller_name: null,
        value: '(214) 226-0764',
        is_contacted: false,
        latest_contacted_date: null,
        commonly_reused_count: 0,
      },
      {
        id: 4664466,
        is_type: 'census_main',
        phone_e164: '+12547441859',
        error_code: null,
        carrier_name: 'AT&T Wireless',
        caller_name: null,
        value: '(254) 744-1859',
        is_contacted: false,
        latest_contacted_date: null,
        commonly_reused_count: 0,
      },
      {
        id: 4664467,
        is_type: 'census_main',
        phone_e164: '+19402061528',
        error_code: null,
        carrier_name: 'AT&T Wireless',
        caller_name: null,
        value: '(940) 206-1528',
        is_contacted: false,
        latest_contacted_date: null,
        commonly_reused_count: 0,
      },
      {
        id: 4630534,
        is_type: 'census_main',
        phone_e164: '+16157858690',
        error_code: null,
        carrier_name: null,
        caller_name: null,
        value: '(615) 785-8690',
        is_contacted: false,
        latest_contacted_date: null,
        commonly_reused_count: 0,
      },
      {
        id: 4643142,
        is_type: 'census_cell',
        phone_e164: '+15154515345',
        error_code: null,
        carrier_name: null,
        caller_name: null,
        value: '(515) 451-5345',
        is_contacted: false,
        latest_contacted_date: null,
        commonly_reused_count: 0,
      },
    ],
    email_addresses: [
      {
        id: 1660314,
        value: 'charniqua92@gmail.com',
        is_type: 'census',
        carrier_id: 3275805,
        commonly_reused_count: 0,
      },
      {
        id: 1661897,
        value: 'clark@highway.com',
        is_type: 'census',
        carrier_id: 3275805,
        commonly_reused_count: 0,
      },
      {
        id: 1661887,
        value: 'jordan@highway.com',
        is_type: 'census',
        carrier_id: 3275805,
        commonly_reused_count: 0,
      },
      {
        id: 1661891,
        value: 'jung@cratebind.com',
        is_type: 'census',
        carrier_id: 3275805,
        commonly_reused_count: 0,
      },
      {
        id: 1661895,
        value: 'lawson@highway.com',
        is_type: 'census',
        carrier_id: 3275805,
        commonly_reused_count: 0,
      },
      {
        id: 1661889,
        value: 'ryan@cratebind.com',
        is_type: 'census',
        carrier_id: 3275805,
        commonly_reused_count: 0,
      },
      {
        id: 1661893,
        value: 'tim@cratebind.com',
        is_type: 'census',
        carrier_id: 3275805,
        commonly_reused_count: 0,
      },
      {
        id: 1688833,
        value: 'timbilestimbiles@gmail.com',
        is_type: 'dispatch',
        carrier_id: 3275805,
        commonly_reused_count: 0,
      },
    ],
    addresses: [
      {
        id: 6690175,
        lat: null,
        lon: null,
        carrier_id: 3275805,
        is_type: 'physical',
        street1: '2314 PEACH BLOSSOM CT',
        street2: '',
        city: 'MURFREESBORO',
        state: 'TN',
        postal_code: '37127',
        commonly_reused_count: 0,
      },
      {
        id: 6718731,
        lat: null,
        lon: null,
        carrier_id: 3275805,
        is_type: 'mailing',
        street1: '2314 PEACH BLOSSOM CT',
        street2: '',
        city: 'MURFREESBORO',
        state: 'TN',
        postal_code: '37127',
        commonly_reused_count: 0,
      },
    ],
  },
  certifications: [],
  equipment_types: [
    {
      id: 425088,
      carrier_id: 3275805,
      is_type: 'van',
      file_date: '2022-02-26',
      equipment_typeable_id: 18,
      equipment_typeable_type: 'OnboardingPacket',
      created_at: '2022-02-26T20:05:56.031-06:00',
      updated_at: '2022-02-26T20:05:56.031-06:00',
    },
    {
      id: 425089,
      carrier_id: 3275805,
      is_type: 'flatbed',
      file_date: '2022-02-26',
      equipment_typeable_id: 18,
      equipment_typeable_type: 'OnboardingPacket',
      created_at: '2022-02-26T20:07:37.533-06:00',
      updated_at: '2022-02-26T20:07:37.533-06:00',
    },
    {
      id: 425090,
      carrier_id: 3275805,
      is_type: 'reefer',
      file_date: '2022-02-26',
      equipment_typeable_id: 18,
      equipment_typeable_type: 'OnboardingPacket',
      created_at: '2022-02-26T20:07:42.977-06:00',
      updated_at: '2022-02-26T20:07:42.977-06:00',
    },
  ],
  specializations: [
    {
      id: 149497,
      carrier_id: 3275805,
      is_type: 'alaska',
      file_date: '2022-02-26',
      specializationable_id: 18,
      specializationable_type: 'OnboardingPacket',
      created_at: '2022-02-26T20:00:10.360-06:00',
      updated_at: '2022-02-26T20:00:10.360-06:00',
    },
    {
      id: 149498,
      carrier_id: 3275805,
      is_type: 'regional',
      file_date: '2022-02-26',
      specializationable_id: 18,
      specializationable_type: 'OnboardingPacket',
      created_at: '2022-02-26T20:01:12.227-06:00',
      updated_at: '2022-02-26T20:01:12.227-06:00',
    },
    {
      id: 149499,
      carrier_id: 3275805,
      is_type: 'ctpat',
      file_date: '2022-02-26',
      specializationable_id: 18,
      specializationable_type: 'OnboardingPacket',
      created_at: '2022-02-26T20:01:26.752-06:00',
      updated_at: '2022-02-26T20:01:26.752-06:00',
    },
  ],
};
